import MeetBotPage from "../../components/meetBot/MeetBotPage";

const MeetBot = () => {
    return <MeetBotPage />;
  };
  export default MeetBot;
  